module.exports = __webpack_public_path__ + "static/media/square-plus-grey.c22d1607.png";